import { render } from "./MessagesCard.vue?vue&type=template&id=7ccf2850"
import script from "./MessagesCard.vue?vue&type=script&lang=js"
export * from "./MessagesCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/koningsnvteaching/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__